import React from 'react';
import { Card, CardContent, CategoryText } from './AnalyticsCard.styles';
import { Text18Regular } from '../../utils/Text/Text.styles';
import { formatPrice } from '../../../utils/util';

const AnalyticsCard = ({ earnings, icon, title }) => {
  return (
    <Card>
      {icon}
      <CardContent>
        <CategoryText>{title}</CategoryText>
        <Text18Regular>${formatPrice(earnings)}</Text18Regular>
      </CardContent>
    </Card>
  );
};

export default AnalyticsCard;
